import { OverlayPanel } from 'primeng/components/overlaypanel/overlaypanel';
import { Router } from '@angular/router';
import { AppStore } from './../core/state/app-store';
import { NotificationsService } from './notifications.service';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { DSNotification } from '../models/notification';
import { IPageInfo } from 'ngx-virtual-scroller';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent implements OnChanges {
  @Input() notifications: DSNotification[] = [];
  @Input() overlayPanel: OverlayPanel;
  @Input() vehicleId: string;
  @Input() type: 'vehicle-notifications' | 'user-notifications' =
    'user-notifications';

  public buffer: DSNotification[] = [];
  public loading = false;
  public loadedAll = false;
  fetchMore(event: IPageInfo): void {
    if (
      this.loadedAll ||
      this.loading ||
      event.endIndex !== this.buffer.length - 1
    ) {
      return;
    }
    this.loading = true;
    switch (this.type) {
      case 'vehicle-notifications': {
        if (this.vehicleId) {
          this.notificationsService
            .loadVehiclesNotifications(this.vehicleId, this.buffer.length, 10)
            .subscribe((chunk) => {
              if (!chunk || chunk[this.vehicleId].length === 0) {
                this.loadedAll = true;
                this.loading = false;
              }
            });
        }
        break;
      }
      case 'user-notifications': {
        this.notificationsService
          .loadUserNotifications(this.buffer.length, 10)
          .subscribe((chunk) => {
            if (chunk.notifications.length === 0) {
              this.loadedAll = true;
              this.loading = false;
            }
          });
        break;
      }
    }
  }
  trackByNotificationID(index: number, notification: DSNotification): number {
    return notification.id;
  }
  constructor(
    private notificationsService: NotificationsService,
    private router: Router,
    private appStore: AppStore
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.notifications && changes.notifications.currentValue) {
      this.buffer = this.notifications || [];
      this.loading = false;
    }
  }

  markAsRead(notification: DSNotification) {
    if (!notification.viewedAt) {
      notification.viewedAt = new Date();
      this.notificationsService.markAsRead(notification.id).subscribe();
    }
  }

  makeAllAsRead() {
    for (let notification of this.notifications) {
      notification.viewedAt = new Date();
    }
    this.notificationsService.markAllAsRead().subscribe();
  }

  selectVehicle(notification: DSNotification) {
    this.router.navigate(['/map']).then(() => {
      this.appStore.selectVehicleById(notification.vehicleId);
    });
  }
  close(event) {
    this.overlayPanel.onCloseClick(event);
  }
}
